import React, { useRef, useState } from 'react';
import { Icon } from "@ant-design/compatible";
import { connect } from "react-redux";
import strings from '../../../../strings';
import { Modal, Input, Card, Button, message, Form } from 'antd';
import { addNewBusinessBranch } from '../../../../redux/actions/branchActions';
import Axios from 'axios';
import { LoadScript, Autocomplete, useLoadScript } from '@react-google-maps/api';
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";


const FormItem = Form.Item;
const AddCustomBranch = ({
    addNewBusinessBranch
}) => {
  const [ loading, setLoading ] = useState(false);
  const [form] = Form.useForm()
  const [ openSignModal, setOpenSignModal ] = useState(true);
  const [ clientAuth, setClientAuth ] = useState({
      uid: "",
      access_token: "",
      client: ""
  });
  const [ branches, setBranches ] = useState([]);
  const [ email, setEmail ] = useState(null);
  const [ password, setPassword ] = useState(null);
  const [ activeKey, setActiveKey ] = useState(1);
  const [ country, setCountry ] = useState("");
  const [ state, setState ] = useState("");
  const [ branchCoord, setBranchCoord ] = useState({
    longitude:null,
    latitude: null
  });
  const [ addressLine1, setAddressLine1 ] = useState("");
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY || "",
    libraries: ["places", "geometry"], 
  });
  const ref = useRef(null);

  const  handleAddBranch = () => {
    const { validateFields } = form;
    if( activeKey === 1){
      validateFields()
      .then(values => {
        setLoading(true)
        Axios.post(`${process.env.REACT_APP_API_BASE_URL}/business_branches`, 
        { data: 
          {...values,
            longitude: branchCoord.longitude,
            latitude: branchCoord.latitude
          }}, 
        {
          headers: {
              uid: clientAuth.uid,
              ["access-token"]: clientAuth.access_token,
              client: clientAuth.client
          }
        })
        .then(res => {
          if (res.status && res.status === 200) {
            form.resetFields();
            setAddressLine1("");
  
            Modal.success({
              title: strings.youSuccessfullyAddedNewBranch,
              onOk: () => setLoading(false)
            });
  
          }
        })
        .catch(err => {
            setLoading(false);
            message.error(err?.response.data ? err.response.data.error : err.message)
        })
      })
    }  
  };

  const businessBranch = async ({ client, uid, access_token }) => {
      try {
        const response = await Axios.get(`${process.env.REACT_APP_API_BASE_URL}/business_branches`, {
          headers: {
            client,
            uid,
            ["access-token"]: access_token
          }
        });
        
        response.data.map((res) => {
          setBranches((prevState) => {
            const isFound = prevState.filter(pr => pr.id === res.id);
            if(isFound.length > 0) return [...prevState];
            return [
              ...prevState,
              {
                id: res.id,
                name: res.name
              }
            ]
          })
        });
      } catch (error) {
        message.error(error.message)
      }
  }

  const handleSubmit = async e => {
    if(email === null) return message.error("Please fill all fields");
    
    try {
      setLoading(true);
      const res = await fetch(
        `${process.env.REACT_APP_MULTI_LEVEL_BASE_URL}/auth/get_uRewards_auth`,
          {
              method: "POST",
              headers: {
              "Content-Type": "application/json",
              },
              body: JSON.stringify({email}),
          }
        );
        const data = await res.json();

        const { client, access_token, uid } = data.data;

        const authData = {
          client,
          uid,
          access_token
        }

        setClientAuth({
          client,
          access_token,
          uid
        })

        setLoading(false);
        setOpenSignModal(false);
        businessBranch(authData);
    } catch (error) {
      setLoading(false);
      if( email === null){
        message.error("Please enter an admin email or staff username");
      }else if( password === null){
        message.error(strings.pleaseEnterPassword);
      }else{
        message.error("Unable to login, ensure username and password are valid");
      }
    }
  };

  const handlePlaceSelect = () => {
    if (ref.current) {
      const place = ref.current.getPlace();
      
      let location = place &&place.geometry && place.geometry.location;
      let latitude = location && location.lat();
      let longitude = location &&location.lng()
    
      if (place.formatted_address) {
        setAddressLine1(place.formatted_address);
        form.setFieldsValue({ address_line1: place.formatted_address });
      }
      setBranchCoord({
        latitude,
        longitude
      })
    }
  };

  const handleAddressChange = (e) => {
    const value = e.target.value;
    setAddressLine1(value);
    form.setFieldsValue({ address_line1: value });
  };

  const renderInput = () => {
    return (
      <Input
        value={addressLine1}
        size="large"
        onChange={handleAddressChange}
        type="text"
        placeholder={strings.enterBranchAddress1}
        style={{ width: "100%" }}
        prefix={<Icon type="environment" style={{ color: "rgba(0,0,0,.25)" }} />}
      />
    );
  };
  
  return (
    <div className="page-container account-screen">
    <Card bordered={false}>
        <Button 
            type="primary" 
            onClick={() => setOpenSignModal(true)} 
            style={{ marginBottom: "30px"}}
        >
            Change Merchant
        </Button>
        <Form layout="vertical" form={form} onFinish={handleAddBranch}>
        {/* Staff Email Input */}
        <FormItem name="name" rules={[{required: true, message: strings.pleaseEnterBranchName}]}>
            <Input
                size="large"
                // type="email"
                prefix={
                <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder={strings.enterBranchName}
            />
        </FormItem>

        <FormItem name="address_line1" rules={[{required: true, message: strings.pleaseEnterBranchAddress1}]}>
          {isLoaded ? (
            <Autocomplete onLoad={(autocomplete) => (ref.current = autocomplete)} onPlaceChanged={handlePlaceSelect}>
              {renderInput()}
            </Autocomplete>
          ) : (
            renderInput()
          )}
        </FormItem>
        <FormItem name="address_line2" rules={[{required: true, message: strings.pleaseEnterBranchAddress2}]}>
          <Input
            size="large"
            // type="email"
            prefix={
            <Icon type="environment" style={{ color: "rgba(0,0,0,.25)" }} />
            }
            placeholder={strings.enterBranchAddress2}
          />
        </FormItem>
        <div style={{display: "flex", alignItems: "center", gap:5}}>
          <FormItem name="country" style={{width: "50%"}}>
            <CountryDropdown
              label={country}
              defaultOptionLabel={strings.selectCountry}
              value={country}
              onChange={(val) => setCountry(val)}
              className="ant-input-lg ant-input"
            />
          </FormItem>

          <FormItem name="state" style={{width: "50%"}}>
            <RegionDropdown
              label={state}
              country={country}
              value={state}
              onChange={(val) => setState(val)}
              className="ant-input-lg ant-input"
              defaultOptionLabel={strings.selectRegion}
            />
          </FormItem>
        </div>

        <FormItem>
            <Button className="" htmlType="submit" type="primary" loading={loading} >Add Branch</Button>
        </FormItem>
        
        
        </Form>
    </Card>

        <Modal
            open={openSignModal}
            onCancel={() => setOpenSignModal(false)}
            title="sign in to account you want to add branch to"
            okText={strings.signIn}
            onOk={handleSubmit}
            confirmLoading={loading}
        >
            <div style={{display: "flex", flexDirection: "column", gap: "20px"}}>
            <Input
                size="large"
                type="email"
                prefix={
                <Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder={strings.enterStaffEmail}
                onChange={(e) => setEmail(e.target.value)}
            />
                
            
            {/* <Input.Password
                size="large"
                prefix={
                <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="password"
                placeholder={strings.password}
                onChange={(e) => setPassword(e.target.value)}
            /> */}
            </div>
            {/* ======Password */}

        </Modal>
    </div>
  )
}

const mapStateToProps = state => ({
  error: state.error,
});

export default connect(mapStateToProps, {
  addNewBusinessBranch,
})(AddCustomBranch);